
define(function (require) {
	const partialQuestion = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsQuestions.hbs');
	const partialRegularArrow = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsRegularArrow.hbs');
	const utils = require ('../detail_utilities.js');

	var getTab = function (doc, readOnlyForm, detailOptions, buildWrapperDivAndContents) {
		var el = $('<section/>', {
			id: 'tab-set-1',
			class: 'wizard-doc-section',
		});

		var contentContainer = [];

		var questionProgress = $('<nav/>', {
			class: 'question-progress',
			'aria-label': i18n.t('CIVICS.NAVIGATION.WIZARD_NAV')
		});

		var questionProgressBar = $('<div/>', {
			class: 'question-progress-bar medium',
			role: 'tablist'
		});

		// Create previous arrow
		var openingBlock = $('<div/>', {
			class: 'control',
		});

		var prevArrowData = {
			direction: "left",
			classes: "progress-arrow",
			ariaLabel: i18n.t('CIVICS.COMMON.PREVIOUS_STEP')
		}

		openingBlock.append(partialRegularArrow($.extend({}, prevArrowData)));
		questionProgressBar.append(openingBlock);

		var activeHeaderId;
		_.forEach(doc.elements, function (ele) {
			// if the tab page has no id, generate a random id for easy access
			// var headerId = ele.id && ele.id.length > 0 ? "progress" + ele.id : "progress" + utils.generateId();
			var headerId = utils.formatId(ele.text, ele.type + '_Progress');
			// Building Question Bar
			var questionData = {
				id: headerId,
				headerTabId: 'header_' + headerId,
				controls: "content" + headerId,
				selected: ele.isFocus,
				disabled: !ele.isFocus,
				longText: ele.text,
				shortText: ele.text
			};

			if (ele.isFocus) {
				activeHeaderId = headerId;
			}

			questionProgressBar.append(partialQuestion($.extend({}, questionData)));
			contentContainer.push({
				headerId: headerId,
				elements: buildWrapperDivAndContents(ele.elements, readOnlyForm, detailOptions),
			});
		});

		var closingBlockSpacer = $('<div/>', {
			class: 'control-spacer',
		});

		// Create next arrow
		var closingBlock = $('<div/>', {
			class: 'control',
		});

		var nextArrowData = {
			direction: "right",
			classes: "progress-arrow",
			ariaLabel: i18n.t('CIVICS.COMMON.NEXT_STEP')
		}

		closingBlock.append(partialRegularArrow($.extend({}, nextArrowData)));

		questionProgressBar.append(closingBlockSpacer);
		questionProgressBar.append(closingBlock);
		questionProgress.append(questionProgressBar);
		el.append(questionProgress);

		// Building Content Container
		$.each(contentContainer, (index, content) => {
			var tabContent = $('<div/>', {
				id: "content_" + content.headerId,
				class: 'tab-content',
				role: 'tabpanel',
				"aria-labelledby": content.headerId,
				"aria-hidden": "true"
			});

			// Fieldset added for the "required field" description
			var fieldsetContent = $('<fieldset/>', {
				class: 'form-group'
			});

			var legendContent = $('<legend/>', {
				class: 'form-group-notes'
			});

			legendContent.append(i18n.t('CIVICS.COMMON_ADD_APPLICANT.FIELDS_REQUIRED1') + ' <em class="required">*</em> ' + i18n.t('CIVICS.COMMON_ADD_APPLICANT.FIELDS_REQUIRED2'));
			fieldsetContent.append(legendContent);

			if (content.headerId === activeHeaderId) {
				tabContent.addClass('displayed').attr("aria-hidden", "false");
			}

			fieldsetContent.append(content.elements);
			tabContent.append(fieldsetContent);
			el.append(tabContent);
		});

		return el;
	};

	return {
		getTab: function (doc, readOnlyForm, detailOptions, buildWrapperDivAndContents) {
			return getTab(doc, readOnlyForm, detailOptions, buildWrapperDivAndContents);
		}
	}
});